import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './RawMaterialSection.module.scss';
import productService from '../../../services/productService';

const BACKEND_URL = 'https://huongtramcomoc.vn';

const RawMaterialSection = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    productService.getPageContent('vung-nguyen-lieu')
      .then(res => setData(res.data))
      .catch(err => {
        console.error("Lỗi tải vùng nguyên liệu:", err);
        // Fallback data
        setData({
            title: "Vùng Nguyên Liệu Tiên Phước",
            featured_image_url: null,
            content: "<p>Nơi những cây Dó Bầu lâu năm hấp thụ linh khí đất trời, trải qua bao mưa nắng để tạo nên những khối trầm hương chất lượng thượng hạng, mang hương thơm vĩnh cửu...</p>"
        });
      });
  }, []);

  if (!data) return null;

  const imageUrl = data.featured_image_url 
    ? `${BACKEND_URL}${data.featured_image_url}` 
    : 'https://placehold.co/800x600/5c4033/ffffff?text=Vung+Nguyen+Lieu'; 

  // Xử lý trích đoạn ngắn gọn
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = data.content;
  const excerptText = tempDiv.textContent || tempDiv.innerText || "";
  // Giới hạn ký tự để không bị tràn trên mobile
  const shortExcerpt = excerptText.length > 200 ? excerptText.substring(0, 200) + "..." : excerptText;

  return (
    <section className={styles.sectionContainer}>
      <div className={styles.layoutWrapper}>
        
        <div className={styles.imageWrapper}>
          <img src={imageUrl} alt={data.title} className={styles.rawImage} />
        </div>

        <div className={styles.contentCard}>
           <span className={styles.subTitle}>Vùng nguyên liệu trầm hương</span>
           <h2 className={styles.title}>{data.title}</h2>
           <p className={styles.excerpt}>{shortExcerpt}</p>
           
           <Link to="/vung-nguyen-lieu" className={styles.readMoreBtn}>
             Khám Phá Ngay &rarr;
           </Link>
        </div>

      </div>
    </section>
  );
};

export default RawMaterialSection;